<template>
  <table class="table no-border table-product-list">
    <thead>
    <tr>
      <td></td>
      <td>货品</td>
      <template v-if="isExistBatchNumber">
        <td class="text-center">批号</td>
        <td class="text-center">有效期</td>
      </template>
      <td class="text-center">数量</td>
      <td class="text-center">单价</td>
      <td class="text-center">金额</td>
    </tr>
    </thead>
    <tbody>
    <tr v-for="item in data" :key="item.id">
      <td width="80">
        <el-tooltip v-if="item.goodsPicture" popperClass="el-tooltip" effect="light"
                    placement="right">
          <compressed-img :src="item.goodsPicture +'?image&action=resize:w_80,h_80,m_2' "
                          class="product-img"/>
          <compressed-img slot="content" :src="item.goodsPicture +'?image&action=resize:h_200,m_2' "
                          class="product-img"/>
        </el-tooltip>
        <el-tooltip v-else effect="light" popperClass="el-tooltip" placement="right">
          <img :src="userPic" class="product-img">
          <img :src="userPic" slot="content" class="product-img">
        </el-tooltip>
      </td>
      <td>
        <div>
          <el-tooltip :content="`货品主档编号:${item.goodsCode} 货品主档ID:${item.goodsId}`" class="item" effect="dark"
                      placement="right">
            <span style="font-size: 14px;line-height: 20px">{{ item.goodsName }}</span>
          </el-tooltip>
        </div>
        <div>
          <el-tooltip class="item" effect="dark" content="货品规格" placement="right">
            <span style="font-size: 12px;">{{ item.specification }}</span>
          </el-tooltip>
        </div>
        <div>
          <el-tooltip class="item" effect="dark" content="供货单位" placement="right">
            <span style="font-size: 12px;">{{ item.supplyManufacturers }}</span>
          </el-tooltip>
        </div>
      </td>
      <template v-if="isExistBatchNumber">
        <td class="text-center" width="100px">
          {{item.batchNumber}}
        </td>
        <td class="text-center" width="100px">
          {{item.expirationDate | date}}
        </td>
      </template>
      <td width="100px" class="text-center">
        {{item.orderAmount}}
        <dict :dict-group="'measurementUnit'" :dict-key="item.measurementUnit"></dict>
        <order-goods-package-count :item="item" :count="item.orderAmount"/>
      </td>
      <td width="80px" class="text-center">
        <span v-if="item.orderPrice">￥{{item.orderPrice}}</span>
        <span v-if="!item.orderPrice">-</span>
      </td>
      <td class="text-center" width="80px">
        <span v-if="item.orderPrice">
            ¥{{ item.orderAmount * item.orderPrice | formatMoney }}
        </span>
        <span v-if="!item.orderPrice">-</span>
      </td>
    </tr>
    <tr class="text-center">
      <td :colspan="isExistBatchNumber ? 5 : 3"></td>
      <td colspan="2" align="right">
        <span style="font-weight:600;" v-if="totalAmount">合计: ¥  {{ totalAmount | formatMoney}}</span>
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
  import userPic from '../../../assets/img/userpic.png';

  export default {
    props: {
      data: {
        type: Array,
        require: true
      }
    },
    data () {
      return {
        userPic
      }
    },
    computed: {
      totalAmount () {
        if(!this.data) return 0;
        let sum = 0;
        this.data.forEach(i => {
          sum += (i.orderAmount * i.orderPrice || 0)
        });
        return sum;
      },
      isExistBatchNumber () {
        return this.data.some(s => s.batchNumber);
      }
    }
  }
</script>
